// eslint-disable-next-line import/prefer-default-export
import loadable from '@loadable/component'

export const InfoBlockRichText = loadable(() => import('./InfoBlockRichText'))
export const InfoBlockMarkdown = loadable(() => import('./InfoBlockMarkdown'))
export type { InfoBlockMarkdownProps } from './InfoBlockMarkdown'
export type { InfoBlockRichTextProps } from './InfoBlockRichText'
